export default __webpack_public_path__ + "static/media/9f5aa42083d2f50c.f7d1a7d3b43c899b691fb7a5252995bb.svg";